export default __webpack_public_path__ + "static/media/arrow-up.89b09642.svg";